import { getVehicleChrono } from '@/services/chrono-service.js'

export default {
  state: {
    chronoData: {},
  },
  getters: {
    isChronoImputationsEmpty(state) {
      return !!state.chronoData.details && state.chronoData.details.length === 0
    },
    isChronoSynthesisEmpty(state) {
      return (
        !!state.chronoData.synthesis &&
        Object.keys(state.chronoData.synthesis).length === 0
      )
    },
    getChronoImputations(state) {
      if (state.chronoData.hasOwnProperty('details')) {
        return state.chronoData.details
      }

      return []
    },
  },
  mutations: {
    SET_CHRONODATA(state, data) {
      state.chronoData = data
    },
  },
  actions: {
    async getVehicleChrono({ commit, rootGetters }, data) {
      let payload = {
        vehicleId: data.vehicleId,
        startDate: data.startDate,
        endDate: data.endDate,
        date: data.date,
      }

      //Get vehicle position markers
      const vehiclePositionMarkers =
        rootGetters['simpliciti_map/vehiclePositionMarkers']

      //Set payload start and end date in history mode, or if there are positions
      if (data.historyEndDatetimeStamp) {
        payload.startDate = data.date
        payload.endDate = new Date(data.historyEndDatetimeStamp)
        delete payload.date
      } else if (vehiclePositionMarkers.length > 0) {
        payload.startDate = new Date(vehiclePositionMarkers[0].dateheure)
        payload.endDate = new Date(
          vehiclePositionMarkers[vehiclePositionMarkers.length - 1].dateheure
        )
        delete payload.date
      }

      let fn = data.getVehicleChrono || getVehicleChrono

      let results = await fn(payload, 'v3')
      commit('SET_CHRONODATA', results)
      return results
    },
  },
}
